
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/bill-of-lading",
      function () {
        return require("private-next-pages/resources/bill-of-lading/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/bill-of-lading"])
      });
    }
  